import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isNpcTeamEntries: false, loading: false };

export const getNpcTeamEntriesEditableReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_SUCCESS:
      return { ...state, isNpcTeamEntries: true, response: action.payload?.data, loading: false };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_FAILURE:
      return {
        ...state,
        isNpcTeamEntries: false,
        response: null,
        error: action.payload,
        loading: false,
      };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.GET_NPC_TEAM_ENTRIES_EDITABLE_RESET:
      return initialState;
    default:
      return state;
  }
};
